/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Styles
import borders from "assets/theme/base/borders";
import typography from "assets/theme/base/typography";

// Soft UI Dashboard PRO React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { borderRadius } = borders;
const { size } = typography;

export default {
  styleOverrides: {
    root: ({ theme }) => ({
      minWidth: pxToRem(160),
      minHeight: "unset",
      padding: `${pxToRem(4.8)} ${pxToRem(16)}`,
      borderRadius: borderRadius.md,
      fontSize: size.sm,
      color: theme.palette.text.primary,
      transition: "color 200ms ease",

      "&:hover, &:focus": {
        backgroundColor: "transparent",
        color:
          theme.palette.mode === "dark" ? theme.palette.common.white : theme.palette.text.primary,
      },

      "&.Mui-selected": {
        backgroundColor: "transparent",
        color: theme.palette.primary.main,
        fontWeight: 500,
      },

      "&.Mui-selected:hover, &.Mui-selected:focus": {
        backgroundColor: "transparent",
        color: theme.palette.primary.main,
      },
    }),
  },
};
